import clafricaMap from "./clafrica-map.json";

const clafricaKeys = Object.keys(clafricaMap).sort(
  (a, b) => b.length - a.length
);
const clafricaMaxKeyLen = clafricaKeys.length ? clafricaKeys[0].length : 0;
const clafricaPrefixes = new Set();

clafricaKeys.forEach((key) => {
  for (let i = 1; i < key.length; i += 1) {
    clafricaPrefixes.add(key.slice(0, i));
  }
});

function applyClafricaToken(token, allowPartialAtEnd) {
  if (!clafricaMaxKeyLen || !token) {
    return token;
  }
  let output = "";
  let i = 0;
  while (i < token.length) {
    let matched = false;
    const maxLen = Math.min(clafricaMaxKeyLen, token.length - i);
    for (let len = maxLen; len > 0; len -= 1) {
      const chunk = token.slice(i, i + len);
      const replacement = clafricaMap[chunk];
      if (replacement) {
        if (
          allowPartialAtEnd &&
          i + len === token.length &&
          clafricaPrefixes.has(chunk)
        ) {
          break;
        }
        output += replacement;
        i += len;
        matched = true;
        break;
      }
    }
    if (!matched) {
      output += token[i];
      i += 1;
    }
  }
  return output;
}

function applyClafricaToText(value, allowPartialAtEnd) {
  if (!value) {
    return value;
  }

  const parts = value.match(/\S+|\s+/g) || [];
  const wordIndexes = [];
  parts.forEach((part, idx) => {
    if (!/^\s+$/.test(part)) {
      wordIndexes.push(idx);
    }
  });

  const lastWordIndex = wordIndexes[wordIndexes.length - 1];
  return parts
    .map((part, idx) => {
      if (/^\s+$/.test(part)) {
        return part;
      }
      const isLastWord = idx === lastWordIndex;
      return applyClafricaToken(part, allowPartialAtEnd && isLastWord);
    })
    .join("");
}

export { applyClafricaToText };
